var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44578 9.335V7.15663C3.44578 3.20413 6.64992 0 10.6024 0C14.5549 0 17.759 3.20413 17.759 7.15663V9.335C18.941 9.42332 19.7106 9.64607 20.2732 10.2087C21.2048 11.1404 21.2048 12.6398 21.2048 15.6386C21.2048 18.6373 21.2048 20.1367 20.2732 21.0684C19.3416 22 17.8422 22 14.8434 22H6.36145C3.36263 22 1.86323 22 0.931613 21.0684C0 20.1367 0 18.6373 0 15.6386C0 12.6398 0 11.1404 0.931613 10.2087C1.49421 9.64607 2.26388 9.42332 3.44578 9.335ZM5.03614 7.15663C5.03614 4.08247 7.52825 1.59036 10.6024 1.59036C13.6766 1.59036 16.1687 4.08247 16.1687 7.15663V9.28093C15.7626 9.27711 15.3221 9.27711 14.8434 9.27711H6.36145C5.88274 9.27711 5.44223 9.27711 5.03614 9.28093V7.15663Z",
    fill: "#A9A7A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyPasswordIcon);
export default __webpack_public_path__ + "static/media/GreyPasswordIcon.c169e2e01218ef644a632e118210e18d.svg";
export { ForwardRef as ReactComponent };